import { MODIFICA_LOADER } from './types';

export const modificaLoader = showLoader => {
    return {
        type: MODIFICA_LOADER,
        payload: showLoader,
    }
}


// WEBPACK FOOTER //
// ./src/actions/LoaderActions.js